<template>
  <div
    v-if="isVisible"
    class="backdrop"
    role="alertdialog"
    aria-modal="true"
    aria-labelledby="timeout-dialog-title"
    aria-describedby="timeout-dialog-description">
    <div class="timeout-dialog">
      <h5 id="timeout-dialog-title">
        {{ tStatic('caiSessionExpiringTitle') }}
      </h5>
      <div class="countdown-ring" aria-hidden="true">
        <span class="countdown-number">{{ countdown }}</span>
      </div>
      <p id="timeout-dialog-description" v-html="tStatic('caiSessionExpiringDescription').replace('{countdown}', countdown)"></p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    countdown: {
      type: Number,
      default: 10
    }
  }
}
</script>

<style scoped lang="scss">
.backdrop {
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 100;
}

.timeout-dialog {
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: flex-start;
  background-color: #fff;
  z-index: 200;
  width: 80%;
  border-radius: 0.5rem;
  padding: 0.75rem;
  margin: auto;
  text-align: center;

  h5 {
    font-size: 1.25rem;
    font-weight: bold;
    margin-bottom: 0.75rem;
    width: 100%;
  }

  p {
    font-size: 13px;
    margin-bottom: 0;
  }
}

.countdown-ring {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  border: 3px solid #1c508b;
  margin-bottom: 0.75rem;
  animation: pulse 1s infinite;
}

.countdown-number {
  font-size: 1.25rem;
  font-weight: bold;
  color: #1c508b;
}

@keyframes pulse {
  0%, 100% { border-color: #1c508b; }
  50%       { border-color: #e74c3c; }
}
</style>
